export default "__VITE_ASSET__9c12ad1e__"